import React from 'react';
import * as util from "../other/util.js";
import * as Backend from "../backend.js";
import ShipCostFormulas from "../share/formulas/ship-cost-formulas.js";
import CompactResourcesView from "./compact-resources-view.js";
import { Link } from "react-router-dom";

// Allows the player to construct new ships on a planet
export default class PlanetShipyardView extends React.Component {

    render() {
        const planet = this.props.planet;

        if (!planet) {
            return (<util.LoadingBar thing={planet} thingName="planet" />);
        }

        if (!planet.ship_construction_project) {
            return (
                <div>
                    <h2>Shipyard</h2>
                    <pre>Must build ship yard first.</pre>
                </div>
            );
        }

        return (
            <div>
                <h2>Shipyard</h2>
                <ShipyardQueue planet={this.props.planet} />
                <h2>New Projects</h2>
                <ShipTable planet={this.props.planet} onBuildShip={(ship_design, quantity) => this.handleBuildShip(ship_design, quantity)} />
            </div>
        );
    }

    handleBuildShip(ship_design, quantity) {
        const planet = this.props.planet;
        const x = planet.x;
        const y = planet.y;
        const z = planet.z;
        Backend.tryStartShipConstruction(x, y, z, ship_design.id, Number(quantity), (res) => {
            if (res.success) {
                this.props.onUpdatePlanet(res.planet);
            } else {
                alert(res.error);
            }
        });
    }
}

class ShipyardQueue extends React.Component {
    render() {
        const planet = this.props.planet;

        if (!planet.ship_construction_project.active) {
            return <pre>No active construction project.</pre>;
        }

        return (
            <div>
                <p className="boring-info-text"> The following list shows the ships queued for construction.
                    The topmost one is currently being constructed.
                    Resources are consumed when the constructing of a ship starts.</p>
                {this.renderConstructionQueue()}
            </div>
        );
    }

    renderConstructionQueue() {
        const planet = this.props.planet;
        this.finish_time = 0;

        return (
            <table className="generic-list">
                <thead>
                    <tr>
                        <td></td>
                        <td>Ship</td>
                        <td>Duration</td>
                        <td>Finished</td>
                    </tr>
                </thead>
                <tbody>
                    {this.renderActiveConstructionEntry()}
                    {planet.ship_construction_project.queue.map((task) => this.renderConstructionQueueEntry(task))}
                </tbody>
            </table>
        );
    }

    renderActiveConstructionEntry() {
        const planet = this.props.planet;
        const project = planet.ship_construction_project;
        this.finish_time = project.finished;

        return (
            <tr>
                <td style={{ width: "5%" }}>
                    1×
                </td>
                <td style={{ width: "40%" }}>
                    {project.ship_design_name}
                </td>
                <td style={{ width: "30%", paddingRight: "12px" }}>
                    <util.Timer date={project.finished} />
                </td>
                <td>
                    {util.RealTime.timePointToHtml(project.finished)}
                </td>
            </tr>
        );
    }

    renderConstructionQueueEntry(task) {
        const planet = this.props.planet;
        const ship_design = util.getGPS().ship_designs.find(ship_design => ship_design.id === task.ship_design_id);

        let time_span = ShipCostFormulas.getShipBuildTime(ship_design.config, planet.buildings.ship_factory);
        time_span *= task.quantity;
        const time_html = (<util.TimeSpan timeSpan={time_span} />);

        this.finish_time += time_span;

        return (
            <tr key={this.finish_time}>
                <td style={{ width: "5%" }}>
                    {task.quantity}×
                </td>
                <td style={{ width: "40%" }}>
                    {ship_design.name}
                </td>
                <td style={{ width: "30%", paddingRight: "12px" }}>
                    {time_html}
                </td>
                <td>
                    {util.RealTime.timePointToHtml(this.finish_time)}
                </td>
            </tr>
        );
    }
}

class ShipTable extends React.Component {
    render() {
        let planet = this.props.planet;
        let ships_designs = util.getGPS().ship_designs;

        if (ships_designs.length === 0) {
            return <pre>No ship designs</pre>;
        }

        return (
            <div>
                <table className="resources">
                    <thead>
                        <tr>
                            <td />
                            <td>
                                <div>Ship</div>
                            </td>
                            <td>
                                <div>Costs</div>
                            </td>
                            <td>
                                <div>Time</div>
                            </td>
                            <td />
                        </tr>
                    </thead>
                    <tbody>
                        {ships_designs.map((ship_design, idx) => {
                            return (<SingleShip key={idx}
                                planet={planet}
                                ship_design={ship_design}
                                onBuildShip={(ship_design, quantity) => this.props.onBuildShip(ship_design, quantity)} />);
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

class SingleShip extends React.Component {
    constructor(props) {
        super(props);
        this.state = { quantity: 1 };
    }

    render() {
        const ship_design = this.props.ship_design;
        const quantity = this.state.quantity;
        const planet = this.props.planet;
        const cost = ShipCostFormulas.getShipBuildCost(ship_design.config);
        cost.scaleVector(this.state.quantity);

        if (ship_design.status !== "In Service") {
            return (
                <div>
                    <Link className="link-button" to={"/game/ship-design/" + ship_design.id}>{ship_design.name}</Link>
                    <span> (Currently under development)</span>
                </div>);
        }

        return (
            <tr>
                <td style={{ width: "60px", padding: "0px" }}>
                </td>
                <td>
                    <Link className="link-button" to={"/game/ship-design/" + ship_design.id}>{ship_design.name}</Link>
                </td>
                <td style={{ textAlign: "right" }}>
                    <CompactResourcesView resources={cost} availableResources={planet.resources} />
                </td>
                <td style={{ textAlign: "right" }}>
                    <util.TimeSpan timeSpan={ShipCostFormulas.getShipBuildTime(ship_design.config, planet.buildings.ship_factory) * quantity} />
                </td>
                <td>
                    <util.KeyValueInput
                        label={"Quantity"}
                        value={quantity}
                        checks={["NUMBER"]}
                        width="60px"
                        maxValue={1000}
                        onChange={(value) => this.handleQuantity(value)} />
                    <div className="action-button" onClick={() => this.props.onBuildShip(ship_design, quantity)}>build</div>
                </td>
            </tr>
        );
    }

    handleQuantity(value) {
        this.setState({ quantity: value });
    }
}
